module.exports = __webpack_public_path__ + "img/car.f2df234b.svg";